import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const RecievedApplications = MatxLoadable({
  loader: () => import("./RecievedApplications")
})

const RecievedApplicationsRoutes = [
  {
    path: "/received_applications",
    component: RecievedApplications,
    auth: authRoles.admin
  }
];

export default RecievedApplicationsRoutes;